module.exports = __webpack_public_path__ + "img/top1.cf1f1026.png";